import { render } from "./SidebarAccordion.vue?vue&type=template&id=1020a62e&scoped=true"
import script from "./SidebarAccordion.vue?vue&type=script&lang=js"
export * from "./SidebarAccordion.vue?vue&type=script&lang=js"

import "./SidebarAccordion.vue?vue&type=style&index=0&id=1020a62e&lang=stylus&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1020a62e"]])

export default __exports__